var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon-play"},[_c('span',{staticClass:"background"}),_vm._v(" "),_c('span',{staticClass:"icon-inner"},[_c('svg',{staticClass:"svg",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 113.14 126.27"}},[_c('polygon',{staticStyle:{"fill":"#fff"},attrs:{"points":"113.14 63.14 0 126.27 0 0 113.14 63.14"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9bc7fea6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/components/app-icon-play/template.html
// module id = null
// module chunks = 